// extracted by mini-css-extract-plugin
export var center = "_1v-2";
export var clickableRow = "_1v-5";
export var expandedRow = "_1v-7";
export var hoverable = "_1v-4";
export var left = "_1v-1";
export var right = "_1v-3";
export var row = "_1v-0";
export var selectedRow = "_1v-6";
export var summaryRow = "_1v-8";